// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// EXTERNAL DEPENDENCY
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseClass } from '../../../../../../../app/modules/shared/components/modals/base_class/modal-base-class';

// SERVICES
import { TokenStorageService } from '../../../../../../../app/state/core/services/token-storage/token-storage.service';
import { AuthStoreService } from '../../../../../../../app/state/modules/auth/auth-store.service';
import { IntercomService } from '../../../../../../../app/state/core/services/intercom-chat-service/intercom-chat-io.service';


// COMPONENTS
import { BusinessSettingComponent } from '../../../../../../modules/main/business/components/business-setting/business-setting.component';

// CONSTANTS
import { AUTH_METHOD_CONSTANTS } from '../../../../../../../app/constants/ngrx-store/auth';
import { ROUTE_CONSTANTS } from '../../../../../../../app/constants/route';
import { UserEditComponent } from '../../../../../../modules/main/business/components/user-edit/user-edit.component';
import { UserStoreService } from '../../../../../../state/modules/user/user-store.service';
import { Subscription } from 'rxjs';
import { AmplitudeService, AMPLITUDE_EVENT } from '../../../../../../core/services/amplitude.service';

@Component({
  standalone: false,
  selector: 'kt-business-user-profile',
  templateUrl: './business-user-profile.component.html',
  styleUrls: ['./business-user-profile.component.scss'],
})
export class BusinessUserProfileComponent extends ModalBaseClass
  implements OnInit, OnDestroy {
  // Public properties
  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;
  displayFreshchatWidget = false;

  user: any = {};
  subs = [];
  sub: Subscription[] = [];
  constructor(
    private router: Router,
    public modalService: NgbModal,
    private authStoreService: AuthStoreService,
    private userStoreService: UserStoreService,
    private tokenStorageServie: TokenStorageService,
    private interCometService: IntercomService,


  ) {
    super(modalService);
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */
  _userData = { pic: '../../../../../../../assets/media/users/100_1.jpg' };

  /**
   * On init
   */
  ngOnInit(): void {
    this.subs.push(this.userStoreService.selecGlobalUser().subscribe((globalUser) => this.user = globalUser));
    this.initFreshchatMethod()
  }

  /**
   * Log out handler
   */
  logout() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_SIGN_OUT, null);

    this.authStoreService.dispatchLogout({
      callback: this.getCallBack.bind(this),
      data: {},
      module: AUTH_METHOD_CONSTANTS.LOGOUT,
    });
  }
  editUserInfo() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_EDIT_USER_INFO, null);
    this.openPopUp(UserEditComponent, null, {
      centered: true,
      size: 'lg',
      keyboard: true,
      backdrop: 'static',
    });

  }

  // Freshchat widget portion start
  initFreshchatMethod() {
    this.subs.push(this.interCometService.isDisplayIntercomWidget$.subscribe(value => {
      this.displayFreshchatWidget = value;
    }));

    // Open if it's already open
    if (this.tokenStorageServie.getChatWidgetStatus()) {
      this.openChat();
    }
  }

  openChat() {
    this.interCometService.openChat();
  }

  closeChat(clearStorage: boolean = false) {
    this.interCometService.closeChat(clearStorage);
  }
  // Freshchat widget portion end

  ngOnDestroy() {
    // Added for Freshchat widget
    this.interCometService && this.interCometService.closeChat();

    // Unsubscribe from all subscriptions to avoid memory leaks
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  /**
   * Log out call back
   */
  getCallBack(res) {
    // clear the fresh chat script if available
    this.tokenStorageServie.clear();
    this.router.navigate([ROUTE_CONSTANTS.CONTAINER.AUTH, ROUTE_CONSTANTS.AUTH.LOGIN]);
  }

  openBusinessSetting() {
    this.openPopUp(BusinessSettingComponent, null, {
      centered: true,
      size: 'xl',
      keyboard: true,
      backdrop: 'static',
    });
  }
}
